import { downloadHealthCertificationQueryFunction } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadHealthCertification/downloadHealthCertificationQueryFunction';
import {
  DownloadHealthCertificationQueryResponseType,
  DownloadHealthCertificationZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadHealthCertification/downloadHealthCertificationQuery.type';

import { MutationOptions } from '@tanstack/react-query';
import { DownloadFilePrintedPicturesZipType } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadFilePrinted/downloadFilePrintedQuery.type';

export const downloadHealthCertificationQueryOptions = (): MutationOptions<
  DownloadHealthCertificationQueryResponseType,
  Error,
  DownloadHealthCertificationZipType
> => ({
  mutationKey: ['downloadHealthCertificationQueryOptions'],
  mutationFn: (params: DownloadFilePrintedPicturesZipType) =>
    downloadHealthCertificationQueryFunction({
      id: params.id,
      show_image: params?.show_image,
    }),
});
